import { SupportComponentBase } from '@app/support/component-base.component';
import { Component, Injector, Input, OnInit } from '@angular/core';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { ActivatedRoute } from '@node_modules/@angular/router';
import { SupportAttachmentDto, SupportDeskTicketDto } from '@shared/service-proxies/general-proxies';
import { SupportDeskService, SupportDeskTicketService } from '@app/support/support.services';
import { BreadcrumbItem } from '@app/shared/common/sub-header/sub-header.component';
import { DatePipe, NgIf } from '@angular/common';
import { MazarsDownloadService } from '@app/modules/mazars-common/services/mazars-download.service';
import { SubHeaderComponent } from '../../../shared/common/sub-header/sub-header.component';
import { MazarsButtonComponent } from '../../../modules/mazars-common/components/mazars-button/mazars-button.component';
import { SupportMessagesComponent } from '../../support-messages/support-messages.component';

@Component({
    selector: 'support-desk-ticket',
    templateUrl: './support-desk-ticket.component.html',
    imports: [
        SubHeaderComponent,
        NgIf,
        MazarsButtonComponent,
        SupportMessagesComponent,
    ],
})
export class SupportDeskTicketBaseComponent extends SupportComponentBase implements OnInit {
    @Input({ required: true }) ticketService: SupportDeskTicketService;
    @Input({ required: true }) tenantId: number | undefined;
    @Input({ required: true }) ticketId: number;
    @Input() accessToken: string | undefined;
    @Input({ required: true }) backlink: string | undefined;
    @Input() additionalContainerClass = '';

    ticket!: SupportDeskTicketDto;

    busy = false;

    protected breadcrumbs = [new BreadcrumbItem(this.l('Support_Desk'))];

    public constructor(
        injector: Injector,
        protected datePipe: DatePipe,
        private downloadService: MazarsDownloadService,
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.spinnerService.show();
        this.ticketService.getTicket(this.ticketId, this.tenantId).subscribe(
            (ticket) => {
                this.ticket = ticket;
                this.breadcrumbs = [
                    new BreadcrumbItem(this.l('Support_Desk'), this.backlink),
                    new BreadcrumbItem(ticket.tenantName),
                    new BreadcrumbItem(ticket.title),
                ];

                this.spinnerService.hide();
            },
            (error) => this.spinnerService.hide(),
        );
    }

    resolve() {
        if (this.busy) {
            return;
        }
        this.busy = true;

        this.ticketService.resolve(this.ticket.id, this.ticket.tenantId ?? undefined).subscribe(
            (ticket) => {
                this.ticket = ticket;
                this.busy = false;
            },
            () => (this.busy = false),
        );
    }

    reopen() {
        if (this.busy) {
            return;
        }
        this.busy = true;

        this.ticketService.reopen(this.ticket.id, this.ticket.tenantId ?? undefined).subscribe(
            (ticket) => {
                this.ticket = ticket;
                this.busy = false;
            },
            () => (this.busy = false),
        );
    }

    download(attachment: SupportAttachmentDto) {
        this.ticketService
            .downloadAttachment(this.ticket.id, this.ticket.tenantId ?? undefined, attachment.id)
            .subscribe((file) => this.downloadService.triggerBrowserDownload(file));
    }

    toYesNo(value: boolean): string {
        if (value) {
            return this.ld('Yes');
        }
        return this.ld('No');
    }
}

@Component({
    template: `
        <div [@routerTransition]>
            <support-desk-ticket [tenantId]="tenantId" [ticketId]="ticketId" [ticketService]="ticketService" [backlink]="basePath"></support-desk-ticket>
        </div>
    `,
    animations: [appModuleAnimation()],
    imports: [SupportDeskTicketBaseComponent],
})
export class SupportDeskTicketComponent extends SupportComponentBase {
    tenantId: number | undefined;
    ticketId: number;

    override basePath = this.basePath + '/desk';

    public constructor(
        injector: Injector,
        protected ticketService: SupportDeskService,
        activatedRoute: ActivatedRoute,
    ) {
        super(injector);

        const tenantId = activatedRoute.snapshot.params['tenantId'];
        this.tenantId = tenantId === 'null' ? undefined : parseInt(tenantId);
        this.ticketId = parseInt(activatedRoute.snapshot.params['ticketId']);
    }
}
